"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTodayOrFuture = exports.formatGroupPeriodDate = exports.nextMonthMm = exports.isValidDuration = exports.dateOfLastDayOfPreviousMonth = exports.settlementPeriodFromHuman = exports.settlementPeriod = exports.settlementPeriodMonth = exports.settlementPeriodYear = exports.monthMm = exports.yearsFrom = exports.years = exports.monthOptionValues = exports.monthNames = void 0;
const dateformat_1 = require("dateformat");
const moment_1 = __importDefault(require("moment"));
const model_1 = require("./model");
require("./utils");
exports.monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
exports.monthOptionValues = exports.monthNames.map((monthName, i) => ({ id: `${i + 1}`.padStart(2, '0'), name: monthName }));
exports.years = Array.range(2018, new Date().getFullYear());
const yearsFrom = (startYear) => Array.range(startYear, new Date().getFullYear());
exports.yearsFrom = yearsFrom;
const monthMm = (month) => {
    let monthNumber;
    if (typeof month === 'number') {
        monthNumber = month;
    }
    else if (month instanceof Date) {
        monthNumber = month.getMonth() + 1;
    }
    else {
        monthNumber = parseInt(month);
        if (isNaN(monthNumber)) {
            monthNumber = (dateformat_1.i18n.monthNames.indexOf(month) % 12) + 1;
        }
    }
    return monthNumber.toString().padStart(2, '0');
};
exports.monthMm = monthMm;
const settlementPeriodYear = (yyyyMm) => yyyyMm.toString().substring(0, 4);
exports.settlementPeriodYear = settlementPeriodYear;
const settlementPeriodMonth = (yyyyMm) => yyyyMm.toString().substring(4, 6);
exports.settlementPeriodMonth = settlementPeriodMonth;
const settlementPeriod = (year, month) => `${year}${(0, exports.monthMm)(month)}`;
exports.settlementPeriod = settlementPeriod;
const settlementPeriodFromHuman = (humanMonthYear) => {
    const [monthName, year] = humanMonthYear.split(' ');
    const mm = monthName !== undefined ? (0, exports.monthMm)(monthName) : '00';
    const yyyy = year !== undefined ? year : '0000';
    return (0, exports.settlementPeriod)(yyyy, mm);
};
exports.settlementPeriodFromHuman = settlementPeriodFromHuman;
const dateOfLastDayOfPreviousMonth = () => {
    const date = new Date(); //  today
    date.setDate(0); //  last day of previous month;
    return date;
};
exports.dateOfLastDayOfPreviousMonth = dateOfLastDayOfPreviousMonth;
const iso8601DurationRegex = /^(-?)P(?=\d|T\d)(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)([DW]))?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:[.,]\d+)?)S)?)?$/;
const isValidDuration = (duration) => !!duration.match(iso8601DurationRegex);
exports.isValidDuration = isValidDuration;
const nextMonthMm = (mm) => {
    const monthIndex = parseInt(mm.toString());
    const nextMonthIndex = monthIndex === 12 ? 1 : monthIndex + 1;
    return nextMonthIndex.toString().padStart(2, '0');
};
exports.nextMonthMm = nextMonthMm;
/**
 * Assumes the startDate is already set to the start of the group period in yyyy-mm-dd format,
 * and returns a readable string representing the group period with the given start date.
 *
 * @param {string} startDate - The start date in yyyy-mm-dd format.
 * @param {GroupPeriod} [groupPeriod] - The group period (e.g., QUARTER, MONTH, WEEK, DAY).
 * @returns {string} A human-readable representation of the group period.
 */
const formatGroupPeriodDate = (startDate, groupPeriod) => {
    switch (groupPeriod) {
        case model_1.GroupPeriod.QUARTER:
            return `${startDate.substring(0, 7)} - ${(0, moment_1.default)(startDate).add(2, 'months').format('YYYY-MM')}`;
        case model_1.GroupPeriod.MONTH:
            return startDate.substring(0, 7); // yyyy-mm-dd -> yyyy-mm
        case model_1.GroupPeriod.WEEK:
            return `${(0, moment_1.default)(startDate).format('YYYY-MM-DD')} - ${(0, moment_1.default)(startDate).add(6, 'days').format('YYYY-MM-DD')}`;
        case model_1.GroupPeriod.DAY: // For GroupPeriod.DAY keep original timestamp
        default:
            return (0, moment_1.default)(startDate).format('YYYY-MM-DD');
    }
};
exports.formatGroupPeriodDate = formatGroupPeriodDate;
const isTodayOrFuture = (date) => {
    return (0, moment_1.default)(date).isSameOrAfter((0, moment_1.default)(), 'day');
};
exports.isTodayOrFuture = isTodayOrFuture;
